export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <header data-testid={testid || "page-header"} className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-[#0B2B33] md:text-3xl">{title}</h1>
        {subtitle ? <p className="mt-1 text-sm text-[#43535E] md:text-base">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}
